







































































import Vue, { VueConstructor } from "vue";
import validationMixin, {
  ValidatableForm,
} from "@/components/mixins/validationMixin";
import VaButton from "@/components/atoms/VaButton.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import PlaylistService from "@/services/playlistService";
import cloneDeep from "lodash/cloneDeep";

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof validationMixin>>
).extend({
  name: "YoutubeMediaPopup",
  mixins: [validationMixin],
  components: {
    VaButton,
    VaTextField,
    VaCard,
  },
  data() {
    return {
      dialog: false,
      ytMedia: {
        companyMediaId: "",
        name: "",
        fileType: "youtube",
        extension: "",
        sizeInBytes: 0,
        note: "",
        downloadUrl: "",
        uploadDate: new Date(),
        playlists: [],
        duration: 0,
        mute: true,
      },
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
      (this.$refs.addYtForm as ValidatableForm).resetValidation();
    },
    onAddYoutube() {
      if ((this.$refs.addYtForm as ValidatableForm).validate()) {
        const ytId = PlaylistService.youtubeParser(
          this.ytMedia.downloadUrl
        ) as string;
        this.ytMedia.downloadUrl = ytId;
        this.ytMedia.companyMediaId = ytId;
        this.$emit("onSelectMedia", cloneDeep(this.ytMedia));
        this.dialog = false;
        this.ytMedia.downloadUrl = "";
        this.ytMedia.name = "";
        this.ytMedia.companyMediaId = "";
      }
    },
  },
});
